var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"table",class:_vm.tableClass},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',{key:column},[_vm._v(_vm._s(column))])})})],2),_vm._t("searching"),_vm._t("body")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }